module.exports = __webpack_public_path__ + "img/knuhospital.3ef3bec7.svg";